import type { NotificationHubTemplateBlockInput } from '../../../../../../__generated__/graphql/types';
import { NotificationHubTemplateBlockTypeEnum } from '../../../../../../__generated__/graphql/types';
import {
  type TResolveMetricLabel,
  blockPropsForContract,
} from '../../../block-props-for-contract';
import type { TEmailEditorBlock } from '../../../mail-canvas/blocks/block-types';

const TYPE_ENUM: Record<
  TEmailEditorBlock['type'],
  NotificationHubTemplateBlockTypeEnum
> = {
  TEXT: NotificationHubTemplateBlockTypeEnum.Text,
  BUTTON: NotificationHubTemplateBlockTypeEnum.Button,
  IMAGE: NotificationHubTemplateBlockTypeEnum.Image,
  DIVIDER: NotificationHubTemplateBlockTypeEnum.Divider,
  METRICS: NotificationHubTemplateBlockTypeEnum.Metrics,
};

export const templateBlockToInput = (
  block: TEmailEditorBlock,
  resolveMetricLabel: TResolveMetricLabel,
): NotificationHubTemplateBlockInput | undefined => {
  const props = blockPropsForContract(block, resolveMetricLabel);

  if (!props) {
    return undefined;
  }

  return {
    id: block.id,
    type: TYPE_ENUM[block.type],
    props,
  };
};
